
import {  jobOrderColNm } from "./jobOrderConstant"
import { shipmentColNm } from "./shipmentConstant"
import { invoiceColNm } from "./invoiceConstant"

export const paymentVoucherApiNm = {
  getPaymentVoucher: "/payment-voucher/getPaymentVoucher",
  generatePaymentVoucherNo: "/payment-voucher/generatePaymentVoucherNo",
  getPayDataFromSubcontract: "/payment-voucher/getPayDataFromSubcontract",
  insertPaymentVoucher: "/payment-voucher/insertPaymentVoucher",
  insertPaymentVoucherWithInvoice: "/payment-voucher/insertPaymentVoucherWithInvoice",
  updatePaymentVoucher: "/payment-voucher/updatePaymentVoucher",
  updatePaymentVoucherColumn: "/payment-voucher/updatePaymentVoucherColumn",
  deletePaymentVoucher: "/payment-voucher/deletePaymentVoucher",
  updateFileName: "/payment-voucher/updateFileName",
  deleteFile: "/payment-voucher/deleteFile",
  uploadFile: "/payment-voucher/uploadFile"
}


export const paymentVoucherColNm =  {
  PVId: "เลขที่สำคัญจ่าย",
  PVNo: "เลขที่สำคัญจ่าย",
  PVDte: "วันที่ทำรายการ",
  PayMthdNm: "วิธีจ่ายเงิน",
  PayMthdId: "วิธีจ่ายเงิน",
  BkSNm: "ธนาคาร",
  BkAccSNm: "ชื่อย่อบัญชี",
  BkAccId: "ชื่อย่อบัญชี",
  NumExp: "รายได้",
  NumRcpt: "ใบเสร็จ",
  NumInv: "Invoice",
  Total: "ยอด Invoice",
  WhtPr: "หัก ณ ที่จ่าย",
  FeeAmnt: "ค่าธรรมเนียม",
  BBNo: "เลขที่สมุดบัญชี",
  BBPage: "หน้า", 
  BBRow : "แถว",
  PayAmnt: "ยอดจ่ายเงิน",
  PayDte: "วันที่จ่ายเงิน",
  DiffAmnt: "ส่วนต่าง",
  DiffDscp: "รายละเอียดส่วนต่าง",
  ChqDte: "วันที่เช็ค",
  ChqNo: "เลขที่เช็ค",
  ChqBkNm: "ธนาคารผู้ออกเช็ค",
  ChqBkId: "ธนาคารผู้ออกเช็ค",
  ChqBrch: "สาขา",
  ChqAmnt: "ยอดหน้าเช็ค",
  TrnBkId: "ธนาคารผู้รับ",
  TrnBkBrch: "สาขา",
  TrnBkAccNo: "เลขที่บัญชีผู้รับ",
  TrnAccNm: "ชื่อบัญชีผู้รับ",
  InvNo: invoiceColNm.InvNo,
  JobNo: shipmentColNm.JobNo,
  BNNo: invoiceColNm.BNNo,
  Rmk: "หมายเหตุ",
  IsCmpt: "Complete",
  CusSNm: jobOrderColNm.CusSNm,
  ModDte: "วันที่แก้ไข",
  ModAcc: "ผู้แก้ไข",
  RcptNo: "เลขที่ใบเสร็จ"
}